import { render, staticRenderFns } from "./batchListOfRegularBatchOrShed.vue?vue&type=template&id=166ea610&scoped=true&"
import script from "./batchListOfRegularBatchOrShed.vue?vue&type=script&lang=js&"
export * from "./batchListOfRegularBatchOrShed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ea610",
  null
  
)

export default component.exports